import React, { FC, useState } from 'react';
import useWindowDimensions from 'shared/lib/hooks/useWindowDimensions';
import Button from 'shared/ui/Button/Button';
import { ICarouselItem } from '../model/types';
import CarouselItem from './CarouselItem/CarouselItem';
import './Carousel.less';

interface ICarouselProps {
  items: ICarouselItem[];
}

const Carousel: FC<ICarouselProps> = (props) => {
  const { items } = props;
  const [position, setPosition] = useState<number>(0);
  const { width } = useWindowDimensions();
  const count = width <= 660 ? 1 : 2;
  return (
    <div className="carousel">
      <div className="gallery">
        <ul className="gallery-ul" style={{ marginLeft: `${position}px` }}>
          {items.map((item) => (
            <CarouselItem item={item} />
          ))}
        </ul>
      </div>
      <div className="controls">
        <Button
          type="button"
          theme="outlined"
          className="btn left"
          onClick={() => {
            // сдвиг влево
            setPosition((prev) =>
              Math.min(
                prev +
                  (document.querySelector('.carousel-img')
                    ?.clientWidth as number) *
                    count,
                0,
              ),
            );
          }}
          suffixIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 40"
              fill="none"
            >
              <g id="arrow right">
                <path
                  id="Union"
                  d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                  fill="#61A0DF"
                  fillOpacity="0.2"
                />
                <path
                  id="Union_2"
                  d="M17.0502 13.2072C16.6596 12.8167 16.6595 12.1835 17.05 11.793C17.4405 11.4024 18.0737 11.4023 18.4642 11.7928L24.3634 17.6908C25.4928 18.82 25.5396 20.6362 24.4697 21.822L18.7425 28.1699C18.3725 28.5799 17.7402 28.6124 17.3301 28.2425C16.9201 27.8725 16.8876 27.2402 17.2575 26.8301L22.9847 20.4822C23.3414 20.0869 23.3258 19.4816 22.9493 19.1052L17.0502 13.2072Z"
                  fill="white"
                />
              </g>
            </svg>
          }
        />
        <Button
          type="button"
          theme="outlined"
          className="btn right"
          onClick={() => {
            const list = document.querySelectorAll('ul.gallery-ul > li');
            setPosition((prev) =>
              Math.max(
                prev -
                  (document.querySelector('.carousel-img')
                    ?.clientWidth as number) *
                    count,
                -(document.querySelector('.carousel-img')
                  ?.clientWidth as number) *
                  (list.length - count),
              ),
            );
          }}
          suffixIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 40"
              fill="none"
            >
              <g id="arrow right">
                <path
                  id="Union"
                  d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                  fill="#61A0DF"
                  fillOpacity="0.2"
                />
                <path
                  id="Union_2"
                  d="M17.0502 13.2072C16.6596 12.8167 16.6595 12.1835 17.05 11.793C17.4405 11.4024 18.0737 11.4023 18.4642 11.7928L24.3634 17.6908C25.4928 18.82 25.5396 20.6362 24.4697 21.822L18.7425 28.1699C18.3725 28.5799 17.7402 28.6124 17.3301 28.2425C16.9201 27.8725 16.8876 27.2402 17.2575 26.8301L22.9847 20.4822C23.3414 20.0869 23.3258 19.4816 22.9493 19.1052L17.0502 13.2072Z"
                  fill="white"
                />
              </g>
            </svg>
          }
        />
      </div>
    </div>
  );
};

export default Carousel;
